import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Drawer from '@mui/material/Drawer';
import MuiDrawer from "@mui/material/Drawer";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import Pagination from '@mui/material/Pagination';
import TablePagination from '@mui/material/TablePagination';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CardActionArea from '@mui/material/CardActionArea';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';
// import TreeView from '@mui/lab/TreeView';
// import TreeItem from '@mui/lab/TreeItem';
import MuiAppBar from '@mui/material/AppBar';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import FormGroup from '@mui/material/FormGroup';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import {
//     GridRowModes,
//     DataGrid,
//     GridToolbarContainer,
//     GridActionsCellItem,
//     GridRowEditStopReasons,
// } from '@mui/x-data-grid';


//Icons Importing 
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import UploadIcon from '@mui/icons-material/Upload';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import HomeIcon from '@mui/icons-material/Home';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import BookIcon from '@mui/icons-material/Book';
import MedicationIcon from '@mui/icons-material/Medication';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import GroupIcon from '@mui/icons-material/Group';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FolderIcon from '@mui/icons-material/Folder';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import DoneIcon from '@mui/icons-material/Done';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import InventoryIcon from '@mui/icons-material/Inventory';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicOffIcon from '@mui/icons-material/MicOff';
import MicIcon from '@mui/icons-material/Mic';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CloseIcon from '@mui/icons-material/Close';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import ReplyIcon from '@mui/icons-material/Reply';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Popover from '@mui/material/Popover';
import GridViewIcon from '@mui/icons-material/GridView';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import StraightenIcon from '@mui/icons-material/Straighten';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import DvrIcon from '@mui/icons-material/Dvr';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import SwipeRightAltIcon from '@mui/icons-material/SwipeRightAlt';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LoginIcon from '@mui/icons-material/Login';
import RemoveIcon from '@mui/icons-material/Remove';
import StickyNote2TwoToneIcon from '@mui/icons-material/StickyNote2TwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import RecyclingTwoToneIcon from '@mui/icons-material/RecyclingTwoTone';
// import LoadingButton from '@mui/lab/LoadingButton';
import FileDownloadTwoToneIcon from '@mui/icons-material/FileDownloadTwoTone';


export const Material = {
    // YearCalendar,
    EditIcon,
    // GridRowModes,
    // DataGrid,
    // GridToolbarContainer,
    // GridActionsCellItem,
    // GridRowEditStopReasons,
    SaveIcon,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    PersonSearchIcon,
    Tabs,
    Tab,
    TabPanel,
    TabList,
    TabContext,
    CorporateFareIcon,
    HorizontalRuleIcon,
    ArrowRightIcon,
    PersonAddIcon,
    UploadIcon,
    FormGroup,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    MobileStepper,
    ReceiptIcon,
    MedicationIcon,
    BookIcon,
    MonitorHeartIcon,
    HomeIcon,
    ExpandLess,
    ExpandMore,
    Collapse,
    GroupIcon,
    LocalAtmIcon,
    CalendarMonthIcon,
    KeyboardDoubleArrowLeftIcon,
    ChevronLeftIcon,
    MuiAppBar,
    DescriptionIcon,
    DownloadIcon,
    CreateNewFolderIcon,
    InsertDriveFileIcon,
    UploadFileIcon,
    FolderIcon,
    ChevronRightIcon,
    ExpandMoreIcon,
    Button,
    // TreeItem,
    // TreeView,
    IconButton,
    ReplyIcon,
    Checkbox,
    TextField,
    AppBar,
    Autocomplete,
    ButtonGroup,
    Box,
    Fab,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    InputAdornment,
    PermIdentityIcon,
    KeyOutlinedIcon,
    VisibilityOffIcon,
    Input,
    ForwardToInboxIcon,
    MenuIcon,
    CreateIcon,
    ManageAccountsIcon,
    CloseIcon,
    MenuItem,
    Container,
    Select,
    Stack,
    Slider,
    Switch,
    ToggleButton,
    ToggleButtonGroup,
    Avatar,
    Badge,
    Chip,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Divider,
    ListItemIcon,
    AccountCircleIcon,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    Typography,
    Toolbar,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    MuiDrawer,
    Card,
    CardContent,
    CardActions,
    Drawer,
    Snackbar,
    Link,
    Menu,
    Pagination,
    VisibilityIcon,
    ApartmentIcon,
    // DateTimePicker,
    MedicalServicesOutlinedIcon,
    LogoutIcon,
    DeleteIcon,
    PersonIcon,
    TablePagination,
    // DesktopDatePicker,
    MuiAlert,
    DashboardIcon,
    CardActionArea,
    AddIcon,
    ScheduleIcon,
    CameraAltIcon,
    AddAPhotoIcon,
    VideoCallIcon,
    DoneIcon,
    PriorityHighIcon,
    InventoryIcon,
    HourglassTopIcon,
    FormatListBulletedIcon,
    AttachMoneyIcon,
    CameraswitchIcon,
    CallEndIcon,
    MicOffIcon,
    MicIcon,
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    CancelIcon,
    ConfirmationNumberIcon,
    // DatePicker,
    ArrowForwardIcon,
    ListAltIcon,
    InputBase,
    SearchIcon,
    Popover,
    GridViewIcon,
    ArrowCircleLeftIcon,
    PrintIcon,
    ShareIcon,
    DesignServicesIcon,
    SquareFootIcon,
    StraightenIcon,
    GpsFixedIcon,
    DvrIcon,
    RefreshIcon,
    PlayArrowIcon,
    SubdirectoryArrowRightIcon,
    SwipeRightAltIcon,
    InfoIcon,
    WarningIcon,
    DangerousIcon,
    CheckCircleOutlineIcon,
    AnnouncementIcon,
    HighlightOffIcon,
    FileDownloadIcon,
    ColorLensIcon,
    LoginIcon,
    RemoveIcon,
    StickyNote2TwoToneIcon,
    PeopleAltTwoToneIcon,
    RecyclingTwoToneIcon,
    // LoadingButton,
    FileDownloadTwoToneIcon
};